import { styled } from "@material-ui/core/styles";
export var ListItemActionGroup = styled("div")(function (_a) {
    var spacing = _a.theme.spacing;
    return ({
        flex: "0 0 auto",
        marginLeft: spacing(4),
        display: "flex",
        alignItems: "center",
        "& > :not(:first-child)": {
            marginLeft: spacing(2),
        },
    });
}, {
    name: "EuiListItemActionGroup",
});
//# sourceMappingURL=ListItemActionGroup.js.map